import type { Middleware } from '@reduxjs/toolkit';
import { wsManager } from '@/lib/websocket';
import { getWebSocketUrl } from '@/config/websocket.config';
import { dataFlowReceived, dqStatsReceived } from '@/state/jobMonitoring.slice';

export const websocketMiddleware: Middleware = (store) => {
    let initialized = false;

    return (next) => (action) => {
        if (!initialized) {
            initialized = true;

            wsManager.connect(getWebSocketUrl());

            wsManager.subscribe('data_flow', (msg) => {
                store.dispatch(dataFlowReceived(msg));
            });

            wsManager.subscribe('dq_stats', (msg) => {
                store.dispatch(dqStatsReceived(msg));
            });
        }

        return next(action);
    };
};